<template>
  <main class="main">
    <h4 class="ml-3">{{ $t("lang.label.meetings_status_processed") }}</h4>
  <section>
    <LoadingSpinner v-if="loading" />

    <div class="row my-4 px-5" v-if="!loading">
      <!-- Tabla de datos -->
      <div class="col-md-12 w-100 mb-3 card p-2" v-if="!loading">
        <div v-if="completeLoading && total > 0" class="row mb-2">
          <div class="col-12">
            <div class="bd-highlight">
              {{ $t("lang.label.results") }}:
              <small v-if="!total" class="ml-1 text-primary"
                >{{ $t("lang.search.calculating") }}...</small
              >
              <strong v-else>{{ total }}</strong>
            </div>
            <div class="text-center mb-2">
              <Pagination
                :total="total"
                :totalpage="meetings.length"
                :model="pagination"
                :limit="false"
                :color="'primary'"
                @changePage="getData"
                key="paginationkey"
              ></Pagination>
            </div>
          </div>
        </div>
        <div class="mx-0 px-0 table-responsive">
          <Table
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="meetings"
            :checkbox="false"
            :notselect="true"
            :model="pagination"
            @goToOpportunity="goToOpportunity"
            @goToClient="goToClient"
          >
          </Table>
        </div>
      </div>
    </div>
  </section>
</main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { linksService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  name: 'MeetingsStatusProcessed',
  data() {
    return {
      meetings: [],
      loading: true,
      completeLoading: false,
      total: 0,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 100,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "status",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: "confirmed_attendance",
                label: "CONFIRMED ATTENDANCE",
                bgColor: "#28a745",
                textColor: "#FFFFFF",                
              },
              {
                id: "rescheduled_meeting",
                label: "RESCHEDULED MEETING",
                bgColor: "#17a2b8",
                textColor: "#FFFFFF",
              },
              {
                id: "unable_to_reach",
                label: "UNABLE TO REACH",
                bgColor: "#28a745",
                textColor: "#FFFFFF",
              },
              {
                id: "cancelled_meeting",
                label: "CANCELLED MEETING",
                bgColor: "#FF0000",
                textColor: "#FFFFFF",
              },
              {
                id: "undefined_meeting",
                label: "NOT APPLICABLE",
                bgColor: "#6c757d",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [          
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity"
          }
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          {
            value: "contact_complete_name",
          },
        ],
        [
          {
            value: "contact_phone",
          },
        ],
        [
          {
            value: "event_date",
          },
        ],
      ],
      headers: [
        {
          label: 'Created',
          percentage: "15%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.label.assign_a_status"),
          percentage: "15%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: this.$t("lang.orders.meeting"),
          percentage: "20%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: this.$t("lang.label.client"),
          percentage: "15%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: 'Attendee Name',
          percentage: "20%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: 'Attendee Phone',
          percentage: "15%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: 'Date',
          percentage: "15%",
          class: "overflowhide",
          id: 7,
        },
      ],
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Pagination,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      headerTab: state => state.header.tab
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  mounted() {
    this.getDataTotal();
    this.getData();
    this.udpdateHeader('meetings_status_processed');
  },
  methods: {  
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),  
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    goToClient(client_id) {      
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    goToOpportunity(link_id) {      
      let url = "/opportunities/" + link_id;
      window.open(url, "_blank");
    },
    getDataTotal() {
      this.total = 0;
      let searchFilter = {
        cantPerPage: this.pagination.cantPerPage,
        currentPage: this.pagination.currentPage,
        getTotal: 1,
      };

      linksService.getMeetingsStatusProcessed(searchFilter)
        .then((res) => {
          if (res !== undefined && res && res.result.total !== undefined) {
            this.total = res.result.total;
          } else {
            this.total = 0;
          }
        })
        .catch((error) => {
          console.error("Error fetching total processed meetings status:", error);
          this.total = 0;
        });
    },
    getData() {
      this.loading = true;

      let searchFilter = {
        cantPerPage: this.pagination.cantPerPage,
        currentPage: this.pagination.currentPage,
        getTotal: 0,
      };

      linksService.getMeetingsStatusProcessed(searchFilter)
        .then((res) => {
          if (res !== undefined && res && res.result) {
            this.meetings = res.result;
            this.loading = false;
            this.completeLoading = true;
          } else {
            this.meetings = [];
            this.loading = false;
            this.completeLoading = true;
          }
        })
        .catch((error) => {
          console.error("Error fetching processed meetings status:", error);
          this.meetings = [];
          this.loading = false;
          this.completeLoading = true;
        });
    },
  },
};
</script>

